import { iDrawTable, setGameplayData, setGUIData, setServerStatus, setSessionData, setSettingsData, setStatusData, tDrawNumber } from "../slices/slice.Game";
import { store } from "../../core.Store";
import { NO_OF_DRAWS } from "../../../_game/config/Game";
// import { __Proxi, __ProxiProvider } from "../../core";

// changes the state of the connection module
export const action_updateServerStatus = (_bIsBusy: any, _lastCommand: any, _errorCode?: number, _errorMessage?: any) => (dispatch: any) => {
 	let lpayload = {
		bIsBusy: _bIsBusy,
		errorCode: 0,
		errorMessage: 'OK',
    lastCommand: '',
	};
	// use 'undefined' to let last command as it was on previous call
	if (typeof _lastCommand !== 'undefined') lpayload.lastCommand = _lastCommand;
	if (typeof _errorCode !== 'undefined') lpayload.errorCode = _errorCode;
	if (typeof _errorMessage !== 'undefined') lpayload.errorMessage = _errorMessage;

  dispatch(setServerStatus(lpayload));
};

// set generic GUI data
// call like this: action_setGUIData({bMenuOpen: false, etc: val})
export const action_setGUIData = (_payload: any) => (dispatch: any) => {
  dispatch(setGUIData(_payload));
};

// set custom gameplay data
export const action_setSessionData = (_payload: any) => (dispatch: any) => {
  dispatch(setSessionData(_payload)); 
};

// set custom gameplay data
export const action_setGameplayData = (_payload: any) => (dispatch: any) => {
 	dispatch(setGameplayData(_payload));
};

export const action_updateStatusData = (_win: number, _credit?: number, _bet?: number) => (dispatch: any) => {
 	let lpayload = {
		 win: undefined,
		 credit: undefined,
		 bet: undefined,
	 } as any;
	// use 'undefined' to let last command as it was on previous call
	if (typeof _win !== 'undefined') lpayload.win = _win;
	if (typeof _credit !== 'undefined') lpayload.credit = _credit;
	if (typeof _bet !== 'undefined') lpayload.bet = _bet;

 	dispatch(setStatusData(lpayload));
};

// use this to change the bet in current STATUS DATA
export const action_setBetValue = (betValue: any) => (dispatch: any) => {
	dispatch(setStatusData({ bet: betValue }));
};

export const action_setSelectedNumbers = (numbers: number[]) => (dispatch: any) => {
	let _newNumbers = {} as iDrawTable;

	for(let i=0; i< numbers.length; i++) {
		_newNumbers[numbers[i]] = {
			isSelected: true,
			isConfirmed: false,
			isDrawed: false,
		} as tDrawNumber;
	}
	dispatch(setGameplayData({
		selectedNumbers: _newNumbers,
	}))
}

export const action_setConfirmedNumbers = (numbers: number[]) => (dispatch: any) => {
	let _newNumbers = {} as iDrawTable;

	for(let i=0; i< numbers.length; i++) {
		_newNumbers[numbers[i]] = {
			isSelected: false,
			isConfirmed: true,
			isDrawed: false,
		} as tDrawNumber;
	}
 
	dispatch(setGameplayData({
		selectedNumbers: _newNumbers,
	}))
}

export const action_setUserTickets = (_tickets: any[]) => (dispatch: any) => {
	dispatch(setGameplayData({
		tickets: _tickets,
	}))
}

export const action_setUserHistory = (_tickets: any[]) => (dispatch: any) => {
	dispatch(setGameplayData({
		history: _tickets,
	}))
}

export const action_setCurrentTicket = (_ticket: any) => (dispatch: any) => {

	if(!_ticket) {
		dispatch(setGameplayData({
			currentTicket: undefined
		}));
		dispatch(action_setConfirmedNumbers([]));
		return;
	}

 	dispatch(setGameplayData({
		currentTicket: _ticket
	}));
 
	let numbers = _ticket.balls.filter((_number: any) => {
		if(_number >0) return _number;
		else return false;
	});
	 
	dispatch(action_setConfirmedNumbers(numbers));
}

export const action_setNextDraws = (nextDraws: number) => (dispatch: any) => {
	if(!NO_OF_DRAWS.includes(nextDraws)) return;

	dispatch(setGameplayData({
		nextDraws: nextDraws,
	}));
}

export const action_setSettingsData = (_payload: any) => (dispatch: any) => { 
 	dispatch(setSettingsData(_payload));
};

// generic gameplay settings setter
export const action_setGameplaySettingsData = (_payload: any) => (dispatch: any) => {
 	dispatch(setGameplayData(_payload));
};
 
export const action_setSelectedNumber = (_payload: number) => (dispatch: any) => {
	let _selectedNumbers = store.getState().game.GAMEPLAY.selectedNumbers;
	let _newNumbers = { ..._selectedNumbers }
	let _number: tDrawNumber = {
		isConfirmed: false,
		isDrawed: false,
		isSelected: true,
	}

	if(_selectedNumbers[_payload]) { 
		_number.isSelected = !_selectedNumbers[_payload].isSelected;
 	} 
	
	_newNumbers[_payload] = _number
 
	dispatch(setGameplayData({
		selectedNumbers: _newNumbers
	}))
}

export const action_cleanSelectedNumbers = () => (dispatch: any) => {
	dispatch(setGameplayData({
		selectedNumbers: {},
	}))
}

export const action_removeUnconfirmedNumbers = () => (dispatch: any) => {
	 
}

export const action_confirmNumberFromTickets = () => (dispatch: any) => {

}
